<div class="settings-page">
  <div class="settings-header">
    <h1>Настройки пользователя</h1>
    <p>Рабочее место, печать и поведение интерфейса.</p>
  </div>

  <form (ngSubmit)="save()" class="settings-form" [formGroup]="userForm">
    <mat-card class="settings-card">
      <mat-card-header>
        <mat-card-title>Профиль</mat-card-title>
        <mat-card-subtitle>Основные данные и рабочее место</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content class="settings-card__content">
        <mat-form-field appearance="outline">
          <mat-label>Имя</mat-label>
          <input matInput type="text" placeholder="Имя пользователя" formControlName="name" />
        </mat-form-field>

        <app-org-selector [control]="orgControl"></app-org-selector>
        <app-warehouse-selector [control]="whControl"></app-warehouse-selector>

        <mat-form-field appearance="outline">
          <mat-label>Фискальная касса</mat-label>
          <mat-select formControlName="fiscal" [compareWith]="compareFiscal">
            <mat-option [value]="null">Не выбрано</mat-option>
            <mat-option *ngFor="let fiscal of fiscalList" [value]="fiscal">
              {{ fiscal.name }}
            </mat-option>
          </mat-select>
          <mat-hint>Эта касса будет использоваться для фискальных продаж и возвратов.</mat-hint>
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card class="settings-card">
      <mat-card-header>
        <mat-card-title>Ringostat</mat-card-title>
        <mat-card-subtitle>SIP и переадресация входящих звонков</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content class="settings-card__content">
        <mat-checkbox formControlName="ringostatEnabled">Активировать Ringostat</mat-checkbox>

        <div class="ringostat-status">
          <label class="ringostat-status__label">Статус звонков</label>
          <mat-button-toggle-group
            class="ringostat-status__toggle"
            formControlName="ringostatAvailabilityStatus"
            aria-label="Статус звонков"
          >
            <mat-button-toggle value="online">Онлайн</mat-button-toggle>
            <mat-button-toggle value="dnd_temporary">Не беспокоить на</mat-button-toggle>
            <mat-button-toggle value="dnd">Не беспокоить</mat-button-toggle>
          </mat-button-toggle-group>

          <mat-form-field *ngIf="isRingostatTemporaryDnd" appearance="outline">
            <mat-label>Минут</mat-label>
            <mat-select formControlName="ringostatDndMinutes">
              <mat-option *ngFor="let minutes of ringostatDndMinuteOptions" [value]="minutes">
                {{ minutes }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="settings-card__grid">
          <mat-form-field appearance="outline">
            <mat-label>Тип направления</mat-label>
            <mat-select formControlName="ringostatDestinationType">
              <mat-option value="sip">SIP account</mat-option>
              <mat-option value="phone">Телефон</mat-option>
              <mat-option value="schema">Схема Ringostat</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field *ngIf="ringostatDestinationType !== 'sip'" appearance="outline">
            <mat-label>{{ ringostatDestinationLabel }}</mat-label>
            <input matInput formControlName="ringostatDestination" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>SIP на компьютере (основной)</mat-label>
            <input matInput formControlName="ringostatSipLogin" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>SIP на телефоне</mat-label>
            <input matInput formControlName="ringostatMobileSipLogin" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Staff ID</mat-label>
            <input matInput formControlName="ringostatStaffId" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Fallback phone</mat-label>
            <input matInput formControlName="ringostatFallbackPhone" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Прямые номера менеджера</mat-label>
            <textarea matInput rows="3" formControlName="ringostatDirectPhones"></textarea>
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="settings-card">
      <mat-card-header>
        <mat-card-title>Печать</mat-card-title>
        <mat-card-subtitle>Параметры для чеков и этикеток</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content class="settings-card__content">
        <mat-form-field appearance="outline">
          <mat-label>Принтер чеков по умолчанию</mat-label>
          <mat-select formControlName="thermalPrinter">
            <mat-option *ngFor="let option of thermalAgentOptions" [value]="option.agentName">
              {{ option.label }}
            </mat-option>
          </mat-select>
          <mat-hint>Этот принтер будет использоваться для печати чеков по умолчанию.</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Профиль этикеток по умолчанию</mat-label>
          <mat-select formControlName="labelProfile">
            <mat-option [value]="null">Не выбрано</mat-option>
            <mat-option *ngFor="let option of labelProfileOptions" [value]="option.key">
              {{ option.label }}
            </mat-option>
          </mat-select>
          <mat-hint>Этот профиль будет использоваться для товарных этикеток и ячеек хранения.</mat-hint>
        </mat-form-field>

        <div class="settings-inline-action">
          <div class="settings-inline-action__copy">
            <strong>Принтеры склада</strong>
            <span>Настройка принтеров, ролей и профилей этикеток для склада.</span>
          </div>
          <button mat-stroked-button type="button" routerLink="/warehouse/printers">Открыть</button>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="settings-card">
      <mat-card-header>
        <mat-card-title>Поведение</mat-card-title>
        <mat-card-subtitle>Что открывать автоматически при запуске и работе с каталогом</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content class="settings-card__content settings-card__content--compact">
        <mat-checkbox formControlName="catalogueOpenFilter">
          Автоматически открывать сохранённый фильтр каталога
        </mat-checkbox>

        <mat-checkbox formControlName="catalogueOpenFolder">
          Автоматически открывать последнюю папку каталога
        </mat-checkbox>
      </mat-card-content>
    </mat-card>

    <div class="settings-actions">
      <button mat-flat-button color="primary" type="submit">Сохранить настройки</button>
    </div>
  </form>
</div>
